module.exports = __webpack_public_path__ + "static/carlsbad-3-328c781780ebb954c1ed7eed91161b72.png";